export const AdsBuyingConstants = {
    ADS_BUYING_STATE: 'auth.application.detail.growth.adsbuying',
};
